module.exports = {"1":"Bad","2":"Poor","3":"Average","4":"Great","5":"Excellent","1.5":"Bad","2.5":"Poor","3.5":"Average","4.5":"Excellent"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/resources/localization/en-US/star-ratings.json
// module id = 1296
// module chunks = 0